import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { AuditLogsRoutingModule } from './audit-logs-routing.module';
import { SharedModule } from 'app/shared/shared.module';
import { AuditLogsListComponent } from './audit-logs-list/audit-logs-list.component';

@NgModule({
  imports: [
    CommonModule,
    AuditLogsRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    AuditLogsListComponent,
  ],
  entryComponents: []
})
export class AuditLogsModule {
}
